import axios from 'axios';
import { API } from '../constants/Constants';

// API base URL - use relative path in development (for proxy), full URL in production
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === 'development' ? '/api' : 'http://backend.leadslisting.in/api');

// Create axios instance with default config
// In development, use relative path to leverage proxy
// In production, use full URL
const apiBaseURL = process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === 'development' ? '/api' : 'http://backend.leadslisting.in/api');

const api = axios.create({
    baseURL: apiBaseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add request interceptor
api.interceptors.request.use(
    (config) => {
        // Get token from localStorage
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
api.interceptors.response.use(
    (response) => response.data,
    (error) => {
        let errorMessage = 'An error occurred while processing your request.';

        if (error.response) {
            // Server responded with error
            errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
        } else if (error.request) {
            // Request made but no response
            errorMessage = 'No response received from server. Please check your connection.';
        } else {
            // Request setup error
            errorMessage = error.message;
        }

        throw new Error(errorMessage);
    }
);

// Auth API endpoints
export const authApi = {
    // Refactored to be more concise. The axios interceptor now handles all errors.
    login: (credentials) => api.post(API.ENDPOINTS.LOGIN, credentials),
    register: (userData) => api.post(API.ENDPOINTS.REGISTER, userData),
    logout: () => api.post(API.ENDPOINTS.LOGOUT)
};

// Business API endpoints
export const businessApi = {
    fetchAll: async () => {
        const response = await api.get(API.ENDPOINTS.BUSINESSES);
        // Handle the API response structure - data is wrapped in a 'data' property
        return response.data || response || [];
    },
    fetchPaginated: (page, limit) => api.get(`${API.ENDPOINTS.BUSINESSES}?page=${page}&limit=${limit}`),
    getById: async (id) => {
        const response = await api.get(`${API.ENDPOINTS.BUSINESSES}?id=${id}`);
        // Handle the API response structure
        const data = response.data || response || [];
        return Array.isArray(data) ? data[0] : data;
    },
    create: (data) => api.post(API.ENDPOINTS.BUSINESSES, data),
    update: (id, data) => api.put(API.ENDPOINTS.BUSINESSES, { id, ...data }),
    delete: (id) => api.delete(`${API.ENDPOINTS.BUSINESSES}?id=${id}`),
    uploadPhoto: (id, formData) => api.post(`${API.ENDPOINTS.UPLOAD}?listing_id=${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
};

// Reviews API endpoints
export const reviewsApi = {
    getByBusinessId: (businessId) => api.get(`/get_reviews.php?business_id=${businessId}`),
    submit: (reviewData) => api.post('/submit_review.php', reviewData),
    replyToReview: (reviewId, replyText) => api.post('/reply_review.php', { reviewId, replyText }),
    reportReview: (reviewId) => api.post('/report_review.php', { reviewId }),
};

// Contact API endpoints
export const SaveLeadApi = {
    sendLead: (formData) => {
        // This was hardcoded to a different URL and used `fetch` inconsistently.
        // Switched to the configured axios instance `api` to use the correct base URL
        // and benefit from centralized interceptors for auth and error handling.
        return api.post('/save_leads.php', formData);
    }
};




export async function saveContactForm({ name, email, message }) {
    // Refactored to use the consistent `api` instance and rely on its error handling.
    return api.post('/save_leads.php', { name, email, message });
}

export default api;
